import React from "react";
import { useTranslation } from "react-i18next";
import FontAwesome from "react-fontawesome";

const Unauthorized = () => {
  const { t } = useTranslation();
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column", // stack vertically
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div className="d-flex align-items-center justify-content-center">
        <h1>{t("Unauthorized")}</h1>
      </div>
      <FontAwesome
        name="lock"
        style={{ fontSize: "3rem", marginBottom: "1rem" }}
      />
      <div className="d-flex align-items-center justify-content-center">
        <h5>
          {t("SubscriptionInquiry")}{" "}
          <a href={"mailto:" + contactEmail}>{contactEmail}</a>
        </h5>
      </div>
    </div>
  );
};

export default Unauthorized;
